<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2024-09-12 16:30:33
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2024-10-08 16:24:59
 * @FilePath: \vue-hepha-order\src\views\product\BomQuery.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form 
                    :form="queryForm" 
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
                <span class="openBtn" v-if="!showForm" @click="showFormPanel(true)">
                    <icon-down-circle size="14"/>
                    {{ $t('base.open') }}
                </span>
                <span class="openBtn" v-else @click="showFormPanel(false)">
                    <icon-up-circle size="14" />
                    {{ $t('base.close') }}
                </span>
            </div>
        </div>

        <Table 
            :table="table"
        >
            <template v-slot:columns="{props}">
                <div v-if="props.column.key == 'inventory'">
                    <div v-if="props.record.inventory.length > 0">
                        <div v-for="(item,index) in props.record.inventory" :key="index" style="font-size:12px;">
                            {{ item.label }}: <span style="display:inline_block;margin-left:10px"> {{ item.value }} </span>
                        </div>
                    </div>
                    <p v-else>-</p>
                </div>
                <div v-if="props.column.key == 'scheduling_quantity'">
                    <div v-if="props.record.scheduling_quantity.length > 0">
                        <div v-for="(item,index) in props.record.scheduling_quantity" :key="index" style="font-size:12px;">
                            {{ item.label }}: <span style="display:inline_block;margin-left:10px"> {{ item.value }} </span>
                        </div>
                    </div>
                    <p v-else>-</p>
                </div>
            </template>

            <template v-slot:searchFilter="{ props }">
                <div class="searchFilter">
                    <a-space direction="vertical">
                    <a-input :model-value="props.filterValue[0]" style="width:164px" @input="(value)=>props.setFilterValue([value])" />
                    <div class="searchFilter-footer">
                        <a-button  style="margin-right:10px" @click="props.handleFilterReset">{{ $t('base.reset') }}</a-button>
                        <a-button type="primary" @click="props.handleFilterConfirm">{{ $t('base.confirm2') }}</a-button>
                    </div>
                    </a-space>
                </div>
            </template>
        </Table>
    </div>
</template>

<script setup>
    import { onMounted, reactive, ref, watch, nextTick, h } from 'vue';
    import { ProductApi } from '@/api/ProductApi.js';
    import { StockOutApi } from '@/api/StockOutApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { BomQuery } from './queryConfig/BomQuery.js';
    import { dateToTimestamp, timestampToDate} from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { IconSearch } from '@arco-design/web-vue/es/icon';

    const localeStore = useLocale()
    const { t } = useI18n()

    const rowData = ref()
    const modalTitle = ref(t('product.addProduct'))
    const queryForm = reactive(BomQuery)
    const showForm = ref(false)
    const skuOption = ref([])
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'60',
                fixed:'left',
                align:'left',
            },
            {
                // title: 'SKU',
                title: t('product.sku'),
                dataIndex: 'sku',
                key:'sku',
                width:'150',
                ellipsis:true,
                tooltip:true,  
                align:'left',
                filterable: {
                    filter: (value, record) => record.sku.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                // title: '物料编码',
                title: t('product.inventoryCode'),
                dataIndex: 'inventory_code',
                key:'inventory_code',
                width:'190',
                ellipsis:true,
                tooltip:true,
                align:'left',
                filterable: {
                    filter: (value, record) => record.inventory_code.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                // title: '产品名称(英文)',
                title: t('product.englishName'),
                dataIndex: 'english_name',
                key:'english_name',
                width:'380',
                ellipsis:true,
                tooltip:true,
                align:'left',
                filterable: {
                    filter: (value, record) => record.english_name.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            // {
            //     // title: '上市年份/车型',
            //     title: t('product.modelYearModel'),
            //     dataIndex: 'model_year_model',
            //     key:'model_year_model',
            //     width:'220',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            // },
            {
                // title: '品牌名称',
                title: t('product.brandName'),
                dataIndex: 'brand_name',
                key:'brand_name',
                width:'130',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '零件名称',
                title: t('product.partName'),
                dataIndex: 'part_name',
                key:'part_name',
                width:'140',
                ellipsis:true,
                tooltip:true,
                align:'left',
                filterable: {
                    filter: (value, record) => record.part_name.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                // title: '库存',
                title: t('product.inventory'),
                dataIndex: 'inventory',
                key:'inventory',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '计划出库数量',
                title: t('product.schedulingQuantity'),
                dataIndex: 'scheduling_quantity',
                key:'scheduling_quantity',
                width:'200',
                ellipsis:true,
                tooltip:true,
                align:'left',
                slotName:'slot'
            },
            {
                // title: '状态',
                title: t('product.inventoryItemStatusCode'),
                dataIndex: 'inventory_item_status_code',
                key:'inventory_item_status_code',
                width:'80',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            {
                // title: '类型名称',
                title: t('product.categoryName'),
                dataIndex: 'category_name',
                key:'category_name',
                width:'180',
                ellipsis:true,
                tooltip:true,
                align:'left',
            },
            // {
            //     // title: '创建日期',
            //     title: t('product.createDate'),
            //     dataIndex: 'create_date',
            //     key:'create_date',
            //     width:'180',
            //     ellipsis:true,
            //     tooltip:true,
            //     align:'left',
            // },
            // {
            //     title: t('base.operate'),
            //     dataIndex: 'Optional',
            //     key:'Optional',
            //     slotName:'optional',
            //     width:'200',
            //     align:'center',
            //     fixed:'right'
            // }
        ],
        configs:{
            scroll:{
                x:1000,
                y:440,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
        },
    })

    const showFormPanel = (val)=>{
        showForm.value = val
    }

    const handle = (type,row)=>{
        switch(type){
            case 'search':
                getbomList()
                break;
            case 'reset':
                queryForm.formData.sku = skuOption.value[0].value
                queryForm.formData.inventory_code = ''
                getbomList()
                break;
        }
    }

    // 列表查询-select
    const handleSelectChange = (val, opt, key)=>{
        console.log(val, key,' keyyyy')
        if(key == 'sku'){
            queryForm.formData.inventory_code = ''
            getbomList()
        }
        if(key == 'inventory_code'){
            queryForm.formData.sku =''
            getbomList()
        }
    }

    // 列表查询-input
    const handleInputClear = (item, val)=>{
        // getbomList()
    }
    const handlePressEnter = (val,item)=>{
        // getbomList()
    }

    const handleInputChange = (item,val)=>{
        
    }

    // 获取Bom列表
    const getbomList = async ()=>{
        let param = {
            inventory_item_id: queryForm.formData.sku || queryForm.formData.inventory_code
        }

        table.value.configs.loading = true
        let res = await ProductApi.getInstance().getEBikeBom(param)
        if(res.code == 0){
            table.value.datas = []
            res.data.list.length > 0 && res.data.list.forEach((item,index)=>{
                let inventory = [],  scheduling_quantity = []
                for(let key in item.inventory){
                    inventory.push({
                        label:key,
                        value:item.inventory[key] + ' ' + item.unit_code
                    })
                }
                for(let key in item.scheduling_quantity){
                    scheduling_quantity.push({
                        label:key,
                        value:item.scheduling_quantity[key] + ' ' + item.unit_code
                    })
                }

                table.value.datas.push({
                    ...item,
                    No: index + 1,
                    inventory: inventory,
                    scheduling_quantity: scheduling_quantity,
                    torque: item.torque == undefined? '-' : item.torque,
                    frame: item.frame == undefined? '-' : item.frame,
                    frame_size: item.frame_size == undefined? '-' : item.frame_size,
                    frame_color: item.frame_color == undefined? '-' : item.frame_color,
                    unit_code: item.unit_code == undefined? '-' : item.unit_code,
                    unit_weight: item.unit_weight == undefined? '-' : item.unit_weight,
                    weight_uom_code:item.weight_uom_code == undefined? '' : item.weight_uom_code,
                    hf_version:item.hf_version == undefined? '-' : item.hf_version,
                    model_year: item.model_year == undefined? '-' : item.model_year,
                    model: item.model == undefined? '-' : item.model,
                    brand_name: item.brand_name == undefined? '-' : item.brand_name,
                    part_name: item.part_name == undefined? '-' : item.part_name,
                    create_date: timestampToDate(item.create_timestamp * 1000)
                })
            })

            table.value.datas.forEach(item=>{
                item.model_year_model = item.model_year == '-' && item.model == '-'? '-' : `${item.model},${item.model_year}`
            })
            table.value.configs.loading = false

            if(res.data.diffFlag){
                Modal.warning({
                    title: t('base.tip'),
                    titleAlign:'start',
                    content: t('product.syncERPToOrderTip'),
                    hideCancel:true,
                    maskClosable:false,
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        syncERPToOrder()
                    }
                }); 
            }
        }else{
            Message.error(res.msg)
        }
    }

    // 同步ERP产品到订单
    const syncERPToOrder = async ()=>{
        table.value.configs.loading = true
        let res = await ProductApi.getInstance().syncERPToOrder()
        if(res.code == 0){
            Message.success(t('base.syncSuccess'))
            getbomList()
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取产品列表,拿到SKU和物料编码下拉数据
    const getSkuAndInventoryCodeList = async ()=>{
        let param = {
            category_code:'627.501'
        }
        let res = await StockOutApi.getInstance().getProductList(param)
        if(res.code == 0){
            let item = queryForm.formField.find(i=>i.key == 'sku')
            let item2 = queryForm.formField.find(i=>i.key == 'inventory_code')
            item.options = []
            item2.options = []
            res.data.length > 0 && res.data.forEach(i=>{
                if(i.category_code == '627.501'){
                    item.options.push({
                        label:i.sku,
                        value:i.inventory_item_id,
                    })
                    item2.options.push({
                        label:i.inventory_code,
                        value:i.inventory_item_id,
                    })
                }
            })
            skuOption.value = item.options
            queryForm.formData.sku = item.options[0].value
        }else{
            Message.error(res.msg)
        }
    }

    // 处理查询面板伸缩时表格高度
    const resetTableHeight = (clientHeight)=>{
        const headerHeight = document.querySelector('.arco-layout-header').clientHeight
        const breadcrumbHeight = document.querySelector('.arco-page-header-with-breadcrumb').clientHeight
        const searchContentDomHeight = document.querySelector('.queryPanel').clientHeight
        const pageHeight = 30
        const footerHeight = document.querySelector('.footer').clientHeight
        table.value.configs.scroll.y = clientHeight - headerHeight - breadcrumbHeight - searchContentDomHeight - pageHeight - footerHeight - 60
    }

    watch(localeStore,(val)=>{
        resetTableHeight(val.clientHeight)
    })

    onMounted(async ()=>{ 
        await getSkuAndInventoryCodeList()
        getbomList()

        nextTick(()=>{
            const clientHeight = document.body.clientHeight
            resetTableHeight(clientHeight)
        })
    })
</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    /deep/ .arco-form-item-layout-inline{
        margin-right: 0;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-tabs-content {
    padding-top: 5px;
}

/deep/ .arco-table-td{
    padding: 0;
    border-bottom: none;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    // padding: 10px 0;
    font-size: 13px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-td .arco-table-cell{
    padding: 0 16px;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-picker-size-medium input,
/deep/ .arco-input-wrapper .arco-input.arco-input-size-medium,
/deep/ .arco-select-view-single.arco-select-view-size-medium .arco-select-view-input{
    font-size:12px;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}

/deep/ .table_pagination{
    display: none !important;
}

.searchFilter{
    padding: 20px;
    background: #fff;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.12), 0px 15px 35px 0px rgba(60, 66, 87, 0.08);
}
</style>